/**
 * @generated SignedSource<<81f63bed55c7ea4266a5b3c03535d0d5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type EventCategoryEnum = "COMPLETE" | "START";
import { FragmentRefs } from "relay-runtime";
export type EventPanel$data = {
  readonly eventTypes: ReadonlyArray<{
    readonly blockedReason: string | null | undefined;
    readonly category: EventCategoryEnum | null | undefined;
    readonly enabled: boolean | null | undefined;
    readonly id: string;
    readonly name: string | null | undefined;
    readonly nameI18nKey: string | null | undefined;
    readonly order: number | null | undefined;
  } | null | undefined> | null | undefined;
  readonly events: {
    readonly " $fragmentSpreads": FragmentRefs<"EventPanelListFragment_event">;
  } | null | undefined;
  readonly id: string | null | undefined;
  readonly " $fragmentType": "EventPanel";
};
export type EventPanel$key = {
  readonly " $data"?: EventPanel$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventPanel">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventPanel",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "EventType",
      "kind": "LinkedField",
      "name": "eventTypes",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "nameI18nKey",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "category",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "order",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "enabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "blockedReason",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 20
        }
      ],
      "concreteType": "EventConnection",
      "kind": "LinkedField",
      "name": "events",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EventPanelListFragment_event"
        }
      ],
      "storageKey": "events(first:20)"
    }
  ],
  "type": "Job",
  "abstractKey": "__isJob"
};
})();

(node as any).hash = "81c62189e3e637ee235b58276781ecf4";

export default node;
